import styled, { css } from 'styled-components'
import { Box, Relative, Token } from '@revolut-internal/ui-kit'

import { MessageColorSchema } from '../../ChatMessage.types'

export const MessageBubbleInteractiveContainer = styled(Relative)<{
  isInteractable: boolean
  isSelected: boolean
}>`
  ${({ isInteractable }) =>
    isInteractable &&
    css`
      cursor: pointer;
      :hover > div {
        filter: brightness(0.8);
      }
    `};

  ${({ isSelected }) =>
    isSelected &&
    css`
      outline: 2px dashed ${Token.color.lightBlue};
      border-radius: ${Token.radius.widget};
      padding: 2px;
    `};
`

export const MessageBubbleContentWrapper = styled(Box)<{
  colorSchema: MessageColorSchema
}>`
  overflow-wrap: break-word;
  position: relative;

  background-image: linear-gradient(
    90deg,
    ${({ colorSchema }) => colorSchema.bgColor},
    ${({ colorSchema }) => colorSchema.bgColor}
  );

  a {
    color: ${({ colorSchema }) => colorSchema.link};
    text-decoration: underline;
  }
`
